import { PermissionKey } from 'components/PermissionsProtectors/protectedComponents.types';
import { planUtils } from 'utils/plan/plan.utils';

export const getCreateDbBtnPermissions = (subscription: Subscription, plan: Plan) => {
  const permissions: PermissionKey = ['bdb_create', 'subscription_get_cluster'];
  const planType = planUtils.getType(plan);

  if (planType === 'pro') {
    permissions.push('rcp_update', 'rcp_provision');
  }

  if (planType === 'active-active') {
    permissions.push('change_request_create', 'change_request_get', 'create_change_execute');
  }

  return permissions;
};
